import { trackError } from '@proposify/frontend-observability';
import type { ZodError } from 'zod';

type ValidationTrackingParams = {
  label: string;
  cause: string;
  error: ZodError;
  responseObj: Record<string, unknown>;
  extraContext?: Record<string, unknown>;
};

export const trackValidationFailure = ({ label, cause, error, responseObj, extraContext }: ValidationTrackingParams) => {
  const missingFields = error.errors
    .filter((issue) => issue.code === 'invalid_type' && issue.received === 'undefined')
    .map((issue) => issue.path.join('.'))
    .filter((path) => path.length > 0);
  const invalidFields = error.errors.map((issue) => ({
    path: issue.path.join('.'),
    message: issue.message,
  }));

  trackError(new Error(`${label} schema validation failed: ${error.message}`), {
    context: {
      errorFrom: 'frontend',
      cause,
      missingFields,
      invalidFields,
      responseKeys: Object.keys(responseObj),
      ...(extraContext ?? {}),
    },
  });
};
